// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/img/Checkbox.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UrediUloge_groupHeadContainer__\\+vfQK {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 24px 0px 48px;
}
.UrediUloge_groupHeadTextContainer__iBy06 {
  cursor: default;
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}
.UrediUloge_groupTitle__ZFZUz {
  color: #4d4d4d;
  cursor: default;
  font-family: Inter;
  font-size: 28px;
  font-weight: 600;
  line-height: 34px;
  letter-spacing: -0.001em;
  margin: 0px;
}
.UrediUloge_groupDateText__fhN-m {
  color: #818c99;
  cursor: default;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  margin: 0px;
}

.UrediUloge_leadersTitleContainer__6bFrO {
  column-gap: 8px;
  display: flex;
}
.UrediUloge_leadersTitle__Ata1g {
  color: #4d4d4d;
  margin: 0px;
}
.UrediUloge_leadersTitle__Ata1g,
.UrediUloge_leadersNumber__u6m8y {
  cursor: default;
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.001em;
}
.UrediUloge_leadersNumber__u6m8y {
  color: #9fa7b2;
  margin: 1px 0px 0px 0px;
}
.UrediUloge_voditeljiContainer__aNY2q {
  display: flex;
  gap: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.UrediUloge_formGroup__k5VNT {
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  max-width: 340px;
  margin-top: 30px;
}
.UrediUloge_Label__8ZZdN {
  font-family: "Inter";
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #828d9a;
  margin-bottom: 2%;
}
.UrediUloge_buttonContainer__kTFxm {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 10px;
  gap: 20px;
}
.UrediUloge_cancelButton__WSxUL {
  background: #ebebeb;
  color: #808080;
}
.UrediUloge_cancelButton__WSxUL,
.UrediUloge_nextButton__bQ7a4 {
  width: 212px;
  height: 52px;
  padding: 8px 16px 8px 16px;
  border-radius: 4px;
  gap: 8px;
  font-family: "Inter";
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: center;
  border: none;
}
.UrediUloge_cancelButton__WSxUL:hover,
.UrediUloge_nextButton__bQ7a4:hover {
  cursor: pointer;
  transition: background-color 300ms ease-in-out;
}
.UrediUloge_cancelButton__WSxUL:hover {
  background-color: #c0c0c0;
}
.UrediUloge_nextButton__bQ7a4:hover {
  background-color: #b38927;
}
.UrediUloge_nextButton__bQ7a4 {
  background: #cb9c2d;
  color: #ffffff;
}
.UrediUloge_label__K2HcT {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding-right: 6px;
}
.UrediUloge_checkboxInput__269xs {
  display: none;
}
.UrediUloge_checkboxInput__269xs:checked + .UrediUloge_checkboxCustom__LFWqB {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center no-repeat;
}
.UrediUloge_checkboxCustom__LFWqB {
  width: 20px;
  height: 20px;
  border: 1px solid #e2e2e2;
  background-color: white;
  border-radius: 8px;
  margin: 6px;
}

.UrediUloge_selectContainer__2s5vJ {
  padding-bottom: 90px;
}

.UrediUloge_disabledBtn__ye-vW {
  background-color: #ebebeb;
  color: #808080;
}

.UrediUloge_disabledBtn__ye-vW:hover {
  background-color: #dbd6d6;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/scenes/singleGroup/Voditelj-UrediUloge/UrediUloge.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,aAAa;AACf;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;;EAEE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;;EAEE,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;AACd;AACA;;EAEE,eAAe;EACf,8CAA8C;AAChD;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,2EAA2E;AAC7E;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB","sourcesContent":[".groupHeadContainer {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin: 24px 0px 48px;\n}\n.groupHeadTextContainer {\n  cursor: default;\n  display: flex;\n  flex-direction: column;\n  row-gap: 8px;\n}\n.groupTitle {\n  color: #4d4d4d;\n  cursor: default;\n  font-family: Inter;\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 34px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n}\n.groupDateText {\n  color: #818c99;\n  cursor: default;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n}\n\n.leadersTitleContainer {\n  column-gap: 8px;\n  display: flex;\n}\n.leadersTitle {\n  color: #4d4d4d;\n  margin: 0px;\n}\n.leadersTitle,\n.leadersNumber {\n  cursor: default;\n  font-family: Inter;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: -0.001em;\n}\n.leadersNumber {\n  color: #9fa7b2;\n  margin: 1px 0px 0px 0px;\n}\n.voditeljiContainer {\n  display: flex;\n  gap: 20px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n.formGroup {\n  margin-bottom: 20px;\n  display: flex;\n  flex-direction: column;\n  max-width: 340px;\n  margin-top: 30px;\n}\n.Label {\n  font-family: \"Inter\";\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #828d9a;\n  margin-bottom: 2%;\n}\n.buttonContainer {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  padding: 10px;\n  gap: 20px;\n}\n.cancelButton {\n  background: #ebebeb;\n  color: #808080;\n}\n.cancelButton,\n.nextButton {\n  width: 212px;\n  height: 52px;\n  padding: 8px 16px 8px 16px;\n  border-radius: 4px;\n  gap: 8px;\n  font-family: \"Inter\";\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: center;\n  border: none;\n}\n.cancelButton:hover,\n.nextButton:hover {\n  cursor: pointer;\n  transition: background-color 300ms ease-in-out;\n}\n.cancelButton:hover {\n  background-color: #c0c0c0;\n}\n.nextButton:hover {\n  background-color: #b38927;\n}\n.nextButton {\n  background: #cb9c2d;\n  color: #ffffff;\n}\n.label {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding-right: 6px;\n}\n.checkboxInput {\n  display: none;\n}\n.checkboxInput:checked + .checkboxCustom {\n  background: url(\"../../../assets/img/Checkbox.png\") center center no-repeat;\n}\n.checkboxCustom {\n  width: 20px;\n  height: 20px;\n  border: 1px solid #e2e2e2;\n  background-color: white;\n  border-radius: 8px;\n  margin: 6px;\n}\n\n.selectContainer {\n  padding-bottom: 90px;\n}\n\n.disabledBtn {\n  background-color: #ebebeb;\n  color: #808080;\n}\n\n.disabledBtn:hover {\n  background-color: #dbd6d6;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"groupHeadContainer": `UrediUloge_groupHeadContainer__+vfQK`,
	"groupHeadTextContainer": `UrediUloge_groupHeadTextContainer__iBy06`,
	"groupTitle": `UrediUloge_groupTitle__ZFZUz`,
	"groupDateText": `UrediUloge_groupDateText__fhN-m`,
	"leadersTitleContainer": `UrediUloge_leadersTitleContainer__6bFrO`,
	"leadersTitle": `UrediUloge_leadersTitle__Ata1g`,
	"leadersNumber": `UrediUloge_leadersNumber__u6m8y`,
	"voditeljiContainer": `UrediUloge_voditeljiContainer__aNY2q`,
	"formGroup": `UrediUloge_formGroup__k5VNT`,
	"Label": `UrediUloge_Label__8ZZdN`,
	"buttonContainer": `UrediUloge_buttonContainer__kTFxm`,
	"cancelButton": `UrediUloge_cancelButton__WSxUL`,
	"nextButton": `UrediUloge_nextButton__bQ7a4`,
	"label": `UrediUloge_label__K2HcT`,
	"checkboxInput": `UrediUloge_checkboxInput__269xs`,
	"checkboxCustom": `UrediUloge_checkboxCustom__LFWqB`,
	"selectContainer": `UrediUloge_selectContainer__2s5vJ`,
	"disabledBtn": `UrediUloge_disabledBtn__ye-vW`
};
export default ___CSS_LOADER_EXPORT___;
